import script from "./ClientProjectDeailAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientProjectDeailAdd.vue?vue&type=script&setup=true&lang=js"

import "./ClientProjectDeailAdd.vue?vue&type=style&index=0&id=54d0890a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54d0890a"]])

export default __exports__